import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    Filter,
    TextInput
} from 'react-admin';

const FeedbackFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="Customer Name" />
        <TextInput source="mobileNo" label="Mobile No" />
    </Filter>
);

export const FeedbackList = (props) => {
    const cityId = sessionStorage.getItem("cityId");
    const userType = atob(sessionStorage.getItem("zutp"));
    const dataFields = <Datagrid>
        <TextField source="name" label="Customer Name" />
        <TextField source="mobileNo" label="Mobile" />
        <TextField source="description" label="Description" />
        <DateField source="creationTime" showTime label="Creation Time" />
    </Datagrid>;
    if (userType === "SA") {
        return (
            <List {...props} title="Feedback" bulkActionButtons={false}
                filters={<FeedbackFilter />} sort={{ field: "creationTime", order: "DESC" }} >
                {dataFields}
            </List>
        );
    } else {
        return (
            <List {...props} title="Feedback" bulkActionButtons={false}
                filters={<FeedbackFilter />} sort={{ field: "creationTime", order: "DESC" }}
                filter={{ cityId: cityId }}>
                {dataFields}
            </List>
        );
    }
};

